import { render, staticRenderFns } from "./modalMoverCarpeta.vue?vue&type=template&id=4cbbd524"
import script from "./modalMoverCarpeta.vue?vue&type=script&lang=js"
export * from "./modalMoverCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports